import React from "react";
import Link from "@qlik/qlik/src/components/Link";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";

/**
 * Component for page navigation.
 * @param {Object} data - The data for the navigation items.
 */
const PageNavigation = ({ data }) => {
    const { cardItem, additionalConfiguration, customId } = data || {};
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "pt-6.25 pb-5.5");
    return (
        <section className={`${sectionSpacingClassName} bg-stone-light transition-colors`} id={customId}>
            <div className="container">
                <ul className="flex flex-wrap lg:flex-nowrap list-none flex-row p-0 m-0 items-end gap-7.5">
                    {cardItem?.cta?.map((ctaItem) => (
                        <li key={ctaItem.id} className="w-full px-0 after:hidden text-center">
                            <Link
                                to={ctaItem.internalLink?.slug}
                                className="relative block w-full pb-3.75 text-gray text-base font-semibold text-center tracking-normal after:bg-gray after:absolute after:w-full after:h-0.75 after:left-0 after:bottom-0.75 hover:no-underline hover:text-green hover:after:bg-green"
                                activeClassName="active text-green after:bg-green pointer-events-none active:text-base"
                            >
                                {ctaItem.text}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default PageNavigation;
